import colormap from 'colormap';

export const generateColorGradient = ({ count = 9 }) => {
  // https://www.npmjs.com/package/colormap
  let colors = colormap({
    colormap: 'hot', // freesurface-blue, hot
    nshades: count > 8 ? count : 9,
    format: 'hex',
    alpha: 1
  });
  const offset = 1;
  return colors.splice(offset, offset + count).reverse();
};

export default generateColorGradient;
